module.exports = __webpack_public_path__ + "static/media/Original Korean - Teaching - Road to Enlightenment (load_2).afcc6613.txt";